export const MESSAGE_LIST = '/message/list/'
export const MESSAGE_SEEN = '/message/seen/'